'use client'
import { TravelClassType } from '@/src/constants/travelers'
import { DeviceType } from '@/src/types/deviceType'
import { JsonsData } from '@/src/types/flight'
import React, { useCallback, useState } from 'react'
import SearchHeaderWrapper from '../searchHeader'
import SrpHeaderWrapper from '../srpHeader'

interface SrpSearchModifierProps {
    jsons: JsonsData | undefined
    from: string
    to: string
    departDate: string
    returnDate: string
    travelers: string
    travelClass: TravelClassType
    deviceType: DeviceType
    srpResultsLoading?: boolean
}

const SrpHeaderWithSearchWrapper: React.FC<SrpSearchModifierProps> = ({
    jsons,
    from,
    to,
    departDate,
    returnDate,
    travelers,
    travelClass,
    deviceType,
    srpResultsLoading
}) => {
    const [searchDrawerOpen, setSearchDrawerOpen] = useState(false)

    const ap = jsons?.ap

    const handleOpenSearchDrawer = useCallback(() => {
        setSearchDrawerOpen(true)
    }, [])

    const handleCloseSearchDrawer = useCallback(() => {
        setSearchDrawerOpen(false)
    }, [])

    return (
        <>
            <SrpHeaderWrapper
                from={srpResultsLoading ? from : ap?.[from]?.c || from}
                to={srpResultsLoading ? to : ap?.[to]?.c || to}
                departDate={departDate}
                returnDate={returnDate}
                travelers={travelers}
                travelClass={travelClass}
                deviceType={deviceType}
                onEditClick={handleOpenSearchDrawer}
            />

            <SearchHeaderWrapper
                srpResultsLoading={srpResultsLoading}
                open={searchDrawerOpen}
                onOpen={handleOpenSearchDrawer}
                onClose={handleCloseSearchDrawer}
                jsons={jsons}
            />
        </>
    )
}

export { SrpHeaderWithSearchWrapper }
export default SrpHeaderWithSearchWrapper
